<div [ngClass]="{'col-12 col-xl-8' : !allSettings}">
  <div class="card">
    <div class="card-header">
      <h5 class="card-title mb-0">{{ 'lumAstcalTitle' | translate }}</h5>
      <h6 class="card-subtitle text-muted mt-1">{{ 'lumAstcalDesc' | translate }}</h6>
    </div>

    <div class="card-body d-flex align-items-center justify-content-center py-5" *ngIf="loading">
      <div class="spinner-border text-primary" role="status">
        <span class="visually-hidden">{{ 'loading' | translate }}</span>
      </div>
    </div>

    <div class="card-body" *ngIf="!loading && astcalData">
      <form>
        <div class="row g-3 align-items-stretch">

          <div class="col-lg-7 position-relative z-1">
            <label class="form-label small mb-1" for="lumAstcalAddress">{{ 'address' | translate }}</label>
            <div class="input-group input-group-sm">
              <span class="input-group-text px-2">
                <i class="fas fa-location-dot text-primary"></i>
              </span>
              <input
                id="lumAstcalAddress"
                class="form-control"
                type="search"
                name="address"
                [(ngModel)]="address"
                (input)="onAddressInput()"
                (blur)="addressSuggestions = []"
                autocomplete="off"
                [placeholder]="'address' | translate"
                [title]="address">
            </div>
            <div class="dropdown-menu show w-100 mt-1 py-1 shadow" *ngIf="addressSuggestions.length">
              <button
                type="button"
                class="dropdown-item text-wrap small"
                *ngFor="let suggestion of addressSuggestions"
                (mousedown)="$event.preventDefault(); selectAddressSuggestion(suggestion)">
                {{ suggestion.name }}
              </button>
            </div>
          </div>

          <div class="col-lg-7 order-lg-1 d-flex">
            <div id="lum-astcal-map" class="w-100 h-100 rounded-3 border z-0" style="min-height: 360px"></div>
          </div>

          <div class="col-lg-7 order-lg-2">
            <div class="d-flex flex-wrap justify-content-around align-items-center gap-3">
              <div class="data-item d-flex align-items-center gap-2">
                <div class="data-icon bg-warning bg-opacity-10">
                  <i class="fas fa-sun text-warning"></i>
                </div>
                <div class="data-content">
                  <div class="data-value">{{ sunriseTime }}</div>
                  <small class="data-label">{{ 'sunrise' | translate }}</small>
                </div>
              </div>
              <div class="data-item d-flex align-items-center gap-2">
                <div class="data-icon bg-secondary bg-opacity-10">
                  <i class="fas fa-moon text-secondary"></i>
                </div>
                <div class="data-content">
                  <div class="data-value">{{ sunsetTime }}</div>
                  <small class="data-label">{{ 'sunset' | translate }}</small>
                </div>
              </div>
              <div class="data-item d-flex align-items-center gap-2">
                <div class="data-icon bg-primary bg-opacity-10">
                  <i class="fas fa-arrows-alt-v text-primary"></i>
                </div>
                <div class="data-content">
                  <div class="data-value">{{ latitude != null ? (latitude | number:'1.4-6') : '--' }}°</div>
                  <small class="data-label">{{ 'latitude' | translate }}</small>
                </div>
              </div>
              <div class="data-item d-flex align-items-center gap-2">
                <div class="data-icon bg-primary bg-opacity-10">
                  <i class="fas fa-arrows-alt-h text-primary"></i>
                </div>
                <div class="data-content">
                  <div class="data-value">{{ longitude != null ? (longitude | number:'1.4-6') : '--' }}°</div>
                  <small class="data-label">{{ 'longitude' | translate }}</small>
                </div>
              </div>
            </div>
          </div>

          <div class="col-lg-5 order-lg-1 d-flex">
            <div class="border rounded-3 p-3 d-flex flex-column w-100">
              <h6 class="mb-3">
                <i class="fas fa-globe-europe text-primary me-2"></i>{{ 'timezone' | translate }}
              </h6>

              <div class="d-flex align-items-center justify-content-between gap-2 mb-3 pb-3 border-bottom">
                <span class="small mb-0">{{ 'lumAstcalTimezoneByLocation' | translate }}</span>
                <label class="switch mb-0 flex-shrink-0">
                  <input
                    type="checkbox"
                    id="lumAstcalTzAuto"
                    name="lumAstcalTzAutoVisual"
                    [attr.aria-label]="'lumAstcalTimezoneByLocation' | translate"
                    [ngModel]="timezoneAutoVisual"
                    (ngModelChange)="onChangeTimezoneAuto($event)">
                  <span class="slider round"></span>
                </label>
              </div>

              <div class="px-3">
              <label class="form-label small mb-1" for="lumAstcalRegion">{{ 'lumTzRegion' | translate }}</label>
              <div class="input-group input-group-sm mb-3">
                <span class="input-group-text px-2">
                  <i class="fas fa-globe-europe text-primary"></i>
                </span>
                <select
                  [disabled]="timezoneAutoVisual"
                  class="form-select"
                  id="lumAstcalRegion"
                  name="region"
                  [(ngModel)]="region"
                  (ngModelChange)="onRegionChange()">
                  <option [ngValue]="''">{{ 'lumTzSelectRegion' | translate }}</option>
                  <option *ngFor="let regionId of regionIds" [ngValue]="regionId">
                    {{ 'lumTzRegion' + regionId | translate }}
                  </option>
                </select>
              </div>

              <label class="form-label small mb-1" for="lumAstcalTimezone">{{ 'timezone' | translate }}</label>
              <div class="input-group input-group-sm mb-3">
                <span class="input-group-text px-2">
                  <i class="fas fa-map-marker-alt text-primary"></i>
                </span>
                <select
                  [disabled]="timezoneAutoVisual || !region"
                  class="form-select"
                  id="lumAstcalTimezone"
                  name="timezone"
                  [(ngModel)]="timezone_city"
                  (ngModelChange)="onTimezoneCityChange()">
                  <option [ngValue]="''">{{ 'lumTzSelectZone' | translate }}</option>
                  <option *ngFor="let city of cities" [ngValue]="city">{{ city }}</option>
                </select>
              </div>

              <div class="input-group input-group-sm">
                <span class="input-group-text px-2">
                  <i class="fas fa-clock text-warning"></i>
                </span>
                <input
                  id="lumAstcalPosix"
                  type="text"
                  class="form-control bg-light text-muted"
                  name="lumAstcalPosix"
                  readonly
                  tabindex="-1"
                  [(ngModel)]="timeZone">
              </div>
              </div>

              <div class="alert alert-danger mt-3 mb-0" role="alert" *ngIf="timezoneAutoError">
                <div class="alert-message">{{ 'timezoneAutoError' | translate }}</div>
              </div>
            </div>
          </div>
        </div>

        <div class="d-flex justify-content-center gap-2 mt-4">
          <button type="button" class="btn btn-primary" (click)="save()" [disabled]="!changesMade">
            {{ 'overwrite' | translate }}
          </button>
          <button type="button" class="btn btn-light" (click)="restore()" [disabled]="!changesMade">
            {{ 'restore' | translate }}
          </button>
        </div>
      </form>

      <div class="alert alert-danger alert-dismissible mt-3 mb-0" role="alert" *ngIf="error">
        <div class="alert-message">{{ error }}</div>
      </div>
      <div class="alert alert-success alert-dismissible mt-3 mb-0" role="alert" *ngIf="successMessage">
        <div class="alert-message">{{ 'updatedSuccesfully' | translate }}</div>
      </div>
    </div>

    <div class="card-body" *ngIf="!loading && !astcalData">
      <div class="alert alert-warning mb-0" role="alert">
        <i class="fas fa-exclamation-triangle me-2"></i>{{ 'lumAstcalPlaceholder' | translate }}
      </div>
    </div>
  </div>
</div>
